import jump from 'jump.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import {emailAnim, emailprocess, emaildone} from '@/js/components/lottie/sendemail'
if(document.querySelector('.altochecks#page')){
    const comoBtn = document.querySelector('.como_btn') 
    const ofreBtn = document.querySelector('.que_btn')
    const contBtn = document.querySelector('.contacto_btn')
    const emailAnim2 = emailAnim()
    const lang = document.documentElement.lang
    const loaderemail = document.querySelector('.loader_sendemail')
    const cont2Btn = document.querySelector('.btn_scroll_contacta')
    const inputemail = document.querySelector('.emailsub')
    const btnemail = document.querySelector('.email_checks_btn')
    const erroremail = document.querySelector('.altochecks#page .contacto_check .error')
    const fullpath = path.value + '/parts/shared/ajax-altochecks-email.php'
    let textSuccess = ''
    let textFail = ''
    function validateEmail(email){
        // var se = /^[\w\.\-_]{1,}@[\w\.\-]{6,}/
        var se = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))){2,6}$/i;
        return se.test(email);
    }

    btnemail.addEventListener('click', ()=>{
        if(validateEmail(inputemail.value)){
            erroremail.classList.remove('active')
            console.log('pasa');
            
            loaderemail.classList.add('active')
            emailprocess(emailAnim2)
            axios.post(fullpath, {
                email: inputemail.value,
                id: 'formaltochecks'
                
              }).then(function (response) {
                  console.log(response);
                if (lang === 'es' || lang === 'es-CL') {
                    textSuccess = response.data[2];
                    textFail = response.data[4];
                 } else {
                   textSuccess = response.data[3];
                    textFail = response.data[5];
                 }
                if(response.data[1]){
                  
                  emaildone(emailAnim2)
                  
                  setTimeout(() => {
                    loaderemail.classList.remove('active')  
                    setTimeout(() => {
                      if(document.querySelector('.solicitademo')) {
                        document.querySelector('.solicitademo').classList.remove('active')
                      }
                      Swal.fire({
      
                        html: `    <div class="popup_exito">
                        <h2>Datos enviados</h2>
                        <img class="check" src="${url.value}wp-content/themes/altotheme/img/check_popup.svg" alt=""> 
                        <div class="bajada">${textSuccess}</div>
                    </div>`,
                        showCloseButton: true,
                        showConfirmButton: false,
                        showCancelButton: false
                      })
                      inputemail.value = '';
                    //   cleanInputs(form)
                    }, 500);
                  }, 1500)
                } else {
                  loaderemail.classList.remove('active') 
                  Swal.fire({
                    type: 'error',
                    html: textFail,
                    confirmButtonText: 'OK'
                  })
                  
                }
                  console.log(response);
              }).catch(err => {
                loaderemail.classList.remove('active') 
              })
        } else{
            erroremail.classList.add('active')
        }
    })
    comoBtn.addEventListener('click', () => jump('.altochecks#page .como'))
    ofreBtn.addEventListener('click', ()=> jump('.altochecks#page .ofrecemos'))
    contBtn.addEventListener('click', ()=>jump('.altochecks#page .contacto_check'))
    // cont2Btn.addEventListener('click', ()=>jump('.altochecks#page .contacto_check'))
    
}